import React, { useState } from 'react'
import { Fade as Hamburger } from 'hamburger-react'
import { PrismicLink } from '@prismicio/react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'

// Components
import BidJSMenu from './bidjsMenu'
import Dropdown from './dropdown'
import Search from './search'

const Header = (showSlices, uid) => {
  const staticData = useStaticQuery(graphql`
    {
      prismicNavigation(lang: { eq: "en-gb" }) {
        ...PrismicNavigationFragment
      }
      prismicConfig(lang: { eq: "en-gb" }) {
        ...PrismicConfigFragment
      }
    }
  `)

  const data = useMergePrismicPreviewData(staticData)
  const headerData = data.prismicNavigation.data
  const config = data.prismicConfig.data

  const [isOpen, setOpen] = useState(false)
  let navStyles = 'flex flex-row w-full justify-between py-3 px-2 lg:px-1 xl:px-2 items-center hover:lg:underline decoration-brand-orange underline-offset-8'
  let subNavStyles = 'flex flex-row py-3 p-2 lg:py-2 group hover:bg-brand-orange hover:text-white'

  return (
    <header role='banner' className={` p-4 text-white border-b border-white/20 bg-brand-blue absolute top-0 left-0 right-0 z-20 whitespace-nowrap`}>
      <nav className='mx-auto max-w-screen-2xl flex flex-row items-center xl:gap-10'>
        <Link className={`${isOpen ? 'fixed z-30 top-5 left-4' : ''}`} to='/'>
          <GatsbyImage className='relative z-30 w-40' image={config.company_logo.gatsbyImageData} alt={config.company_display_name || ''} />
        </Link>
        <span className={`z-30 ml-auto lg:hidden ${isOpen ? 'fixed top-4 right-4 bg-brand-blue' : ''}`}>
          <Hamburger color='currentColor' label='Show menu' rounded toggled={isOpen} toggle={setOpen} />
        </span>
        <div
          className={`${
            !isOpen ? 'tw-hidden' : 'fixed inset-0 z-10 flex h-screen flex-1 flex-col justify-start bg-white bg-opacity-10 p-2 lg:p-0'
          } backdrop-blur-sm lg:relative lg:flex lg:h-auto lg:w-full lg:flex-row lg:bg-transparent`}>
          <div className='w-full max-h-screen overflow-y-scroll rounded-xl bg-brand-blue shadow-md lg:max-h-none lg:overflow-visible lg:rounded-none lg:bg-transparent lg:shadow-none'>
            <ul className='w-full relative gap-2 xl:gap-4 flex flex-col lg:items-center pt-20 px-4 text-xl lg:flex-row lg:pt-0'>
              {headerData.nav.map((nav, index) => {
                return (
                  <React.Fragment key={`nav-${index}`}>
                    {nav.items.length > 1 ? (
                      <Dropdown items={nav.items} navStyles={navStyles} subNavStyles={subNavStyles}>
                        {nav.primary.label}
                      </Dropdown>
                    ) : (
                      <li className='' key={`nav-${index}`}>
                        <PrismicLink className={navStyles} field={nav.primary.link}>
                          {nav.primary.label}
                        </PrismicLink>
                      </li>
                    )}
                  </React.Fragment>
                )
              })}
              <li className='w-full flex flex-grow order-first lg:items-center lg:order-none'>
                <Search />
              </li>
              <li className='x-bidlogix--authenticated-hide'>
                <a href='/auctions/#!/account' className={navStyles} onClick={() => setOpen(false)}>
                  Register
                </a>
              </li>
              <li role='presentation' className='tw-hidden lg:flex w-px h-6 bg-white' />
              <li className='x-bidlogix--authenticated-hide'>
                <a href='/auctions/#!/login' className={navStyles} onClick={() => setOpen(false)}>
                  Log In
                </a>
              </li>
              <BidJSMenu navStyles={navStyles} subNavStyles={subNavStyles} />
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
